module.exports = __webpack_public_path__ + "img/1-10.0fa66118.png";